import HomeComponent1 from "../../components/HomeComponents/HomeComponent1/HomeComponent1";
import HomeComponent4 from "../../components/HomeComponents/HomeComponent4/HomeComponent4";
import HomeComponent8 from "../../components/HomeComponents/HomeComponent8/HomeComponent8";
import HomeComponent9 from "../../components/HomeComponents/HomeComponent9/HomeComponent9";
import HomeComponent10 from "../../components/HomeComponents/HomeComponent10/HomeComponent10";
import HomeComponent11 from "../../components/HomeComponents/HomeComponent11/HomeComponent11";
import HomeComponent12 from "../../components/HomeComponents/HomeComponent12/HomeComponent12";
import HomeComponent13 from "../../components/HomeComponents/HomeComponent13/HomeComponent13";
import HomeComponent14 from "../../components/HomeComponents/HomeComponent14/HomeComponent14";
import HomeComponent15 from "../../components/HomeComponents/HomeComponent15/HomeComponent15";


const Homepage = () => {
  return (
    <div>
      <HomeComponent1 />
      <HomeComponent4 />
      <HomeComponent8 />
      <HomeComponent9 />
      <HomeComponent10 />
      <HomeComponent11 />
      <HomeComponent12 />
      <HomeComponent13 />
      <HomeComponent14 />
      <HomeComponent15 />
      {/* <HomeComponent5 /> */}
      {/* <HomeComponent6 /> */}
      {/* <HomeComponent2 /> */}
      {/* <HomeComponent7 /> */}
      {/* <HomeComponent3 /> */}
    </div>
  );
};

export default Homepage;
